import React from 'react';
import Uganda_p3 from './uganda_p3';
import Uganda_p3_subjects from './uganda_p3_subjects';
const Uganda_p3soc = () => {
  return (
    <div>
      <Uganda_p3 />
    <Uganda_p3_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1>Social Studies</h1>
      <h3>Social studies content</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in social studies learning and assessment </li>
      <li>Cross-cutting isues integrated in social studies learning and assessment </li>
      <li>Values integrated in social studies learning and assessment </li>
      </div>
    </div>
  );
}

export default Uganda_p3soc;